// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const EngagementRingLinkFragmentDoc = gql`
    fragment engagementRingLink on CatalogueEngagementRing {
  __typename
  catalogueCode
  primaryMetal {
    systemCode
  }
  centreStoneConstraints {
    shape {
      systemCode
    }
  }
  suffixSlug
  slug
  grande {
    catalogueCode
  }
  nonGrande {
    catalogueCode
  }
}
    `;